import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckBlockComponent } from './check-block/check-block.component';
import { CheckBlockContainerComponent } from './check-block-container/check-block-container.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CheckBlockComponent, CheckBlockContainerComponent],
  exports: [CheckBlockComponent, CheckBlockContainerComponent]
})
export class CheckBlockModule {}
